export default __webpack_public_path__ + "6cd11043fb4ed313b296839a35efeb42.svg";